export default {
	subscriptions: 'Subscriptions',
	'subscription.details': 'Subscription Details',
	'subscription.timeline.ORDER_CREATED': 'Subscription created',
	'subscription.timeline.ORDER_DISPATCHED': 'Subscription dispatched',
	'subscription.timeline.REFUND_ISSUED':
		'Refund of {{currency}} {{amount}} issued',
	'subscription.timeline.PARTIAL_REFUND_ISSUED':
		'Partial refund of {{currency}} {{amount}} issued',
	'subscription.timeline.ORDER_PAYMENT':
		'{{ordinal}} subscription payment made',
	'subscription.timeline.SUBSCRIPTION_CANCELLED': 'Subscription cancelled',
	'subscription.timeline.MERCHANT': 'Merchant',
	'subscription.timeline.NEW_CARD_ADDED': 'New card added',
	'subscription.timeline.ADMIN': 'cashew admin',
	'subscription.timeline.CUSTOMER': 'Customer',
	'subscription.timeline.SYSTEM': 'System',
	'timeline.subscription.title': 'Subscription timeline',
	'timeline.subscription.status': 'Subscription status',
	'timeline.subscription.payments': 'Payments',
	'timeline.subscription.filterTitle': 'Subscription timeline filter',
	'order.timeline.CUSTOMER_LANDED_ON_REGISTRATION_PAGE':
		'Customer landed on registration page',
	'order.timeline.CUSTOMER_LANDED_ON_OTP_PAGE': 'Customer landed on OTP page',
	'order.timeline.CUSTOMER_VERIFIED_OTP': 'Customer verified OTP',
	'order.timeline.CUSTOMER_RESEND_OTP': 'Customer resend an OTP',
	'subscription.timeline.CUSTOMER_LANDED_ON_REGISTRATION_PAGE':
		'Customer landed on registration page',
	'subscription.timeline.CUSTOMER_LANDED_ON_OTP_PAGE':
		'Customer landed on OTP page',
	'subscription.timeline.CUSTOMER_VERIFIED_OTP': 'Customer verified OTP',
	'subscription.timeline.CUSTOMER_RESEND_OTP': 'Customer resend an OTP',
};
